import { InstructionalVideoDto } from "../model/InstructionalVideoDtos"
import HttpClient, { emptyPageListResponse } from "../../../core/api/httpClient"
import { queryBuilder } from "../../../core/api/queryBuilder"
import { PagedList } from "../../../core/api/pagedList"
import { toast } from "react-toastify"
import { t } from "i18next"
import { MarkAsWatched, UpsertInstructionalVideoWatchLogRequest } from "./instructionalVideoRequests"

const baseUrl = '/api/instructional-videos'
const markAsWatchedUrl = `${baseUrl}/mark-watched/`
const markAsUnwatchedUrl = `${baseUrl}/mark-unwatched/`

export default class InstructionalVideosApi {

    static async getVideos(odataQueryParameters?: string): Promise<PagedList<InstructionalVideoDto>> {

        try {
            const defaultQueryParameters = queryBuilder.build(undefined, 'sequenceNo', undefined, 1, 25)
            const url = `${baseUrl}${odataQueryParameters ? `?${odataQueryParameters}` : `${defaultQueryParameters}`}`
            const response = await HttpClient.get(url)
            if (!response.ok) {
                throw new Error(`Failed to fetch videos: ${response.statusText}`)
            }
            return response.json()
        } catch (error) {
            return emptyPageListResponse(25)
        }
    }

    static async getVideo(id: string): Promise<InstructionalVideoDto|undefined> {
        try {
            const response = await HttpClient.get(`${baseUrl}/${id}`)

            if (!response.ok) {
                throw new Error(`Failed to fetch video: ${response.statusText}`)
            }

            return response.json()
        } catch (error) {
            return undefined
        }
    }

    static async upsertInstructionalVideoWatchLog(request: UpsertInstructionalVideoWatchLogRequest): Promise<void> {
        try {
            const requestMessage = {
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(request)
            }
            const response = await HttpClient.post(baseUrl, requestMessage)
        } catch (error) {
            return undefined
        }
    }

    static async markAsWatched(id: number): Promise<boolean> {
        try {
            const request: MarkAsWatched = {
                id: id
            }
            const requestMessage = {
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(request)
            }
            const response = await HttpClient.post(markAsWatchedUrl, requestMessage)
            return response.ok
        } catch (error) {
            toast.error(t("Something went wrong"))
            return false
        }
    }

    static async markAsUnwatched(id: number): Promise<boolean> {
        try {
            const request: MarkAsWatched = {
                id: id
            }
            const requestMessage = {
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(request)
            }
            const response = await HttpClient.post(markAsUnwatchedUrl, requestMessage)
            return response.ok
        } catch (error) {
            toast.error(t("Something went wrong"))
            return false
        }
    }
}
